module.exports = __webpack_public_path__ + "img/parallax-text-right.a0b96fd1.svg";